import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'lenis/dist/lenis.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeContextProvider from './contexts/ThemeContext'


import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Toaster } from 'react-hot-toast';

ReactDOM.render(
    <ThemeContextProvider>
      <App />
      <Toaster/>
    </ThemeContextProvider>,
  document.getElementById('root')
);


reportWebVitals();
